import * as types from './types'

export default {
  'workorder.status': types.SESSION_WORKORDERSTATUS,
  'workorder.cancelreason': types.SESSION_CANCELREASONS,
  'workorder.calibratereason': types.SESSION_CALIBRATEREASONS,
  'workorder.calibratesystem': types.SESSION_CALIBRATESYSTEMS,
  'workorder.calibratefixture': types.SESSION_CALIBRATEFIXTURES,
  'workorder.calibrateimage': types.SESSION_CALIBRATEIMAGES,
  'workorder.calibratenote': types.SESSION_CALIBRATENOTES,
  configuration: types.SESSION_DYNAMIC_CONFIGURATION
}
